import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-network-status-info',
    templateUrl: './network-status-info.component.html',
    styleUrls: ['./network-status-info.component.scss'],
    imports: [MatIconModule, TranslateModule],
})
export class NetworkStatusInfoComponent {
    @Input() public status: 0 | 1;
}
